import { GET_MENU } from "./types";

export const getMenu = () => async (dispatch, getState) => {
	const {
		databasesRef: { menuDB },
	} = await getState().auth;

	try {
		const menu = await menuDB.get();
		let payload = [];
		for (const doc of menu.docs) {
			payload = [...payload, { ...doc.data(), _id: doc.id }];
		}

		dispatch({ type: GET_MENU, payload });
	} catch (error) {
		alert("Ocurrio un error");
		console.log(error);
	}
};
